import { validateCryptoAddress, type CryptoAddressValidationErrorCode } from './validate-crypto-address';

const HYPHEN_TO_CANONICAL: Record<string, string> = {
  'TRC-20': 'TRC20',
  'ERC-20': 'ERC20',
  'BEP-20': 'BEP20',
};

export type AddressValidationErrorCode = CryptoAddressValidationErrorCode;

export const validateUsdtAddress = async (address: string, network: string) => {
  const canonical = HYPHEN_TO_CANONICAL[network] ?? network.replace(/-/g, '').toUpperCase();
  return validateCryptoAddress(address, canonical);
};

export { validateCryptoAddress };
